type KeywordItem = { name?: string } | string;

interface INonKeywordGroupItemClickOptions {
    onItemClickCustom?: (item: KeywordItem) => void;
    supportCountryFilters: boolean;
    onCountryFilterClick: (keyword: string) => void;
    onDefaultClick: () => void;
}

export const handleNonKeywordGroupItemClick = (
    item: KeywordItem,
    {
        onItemClickCustom,
        supportCountryFilters,
        onCountryFilterClick,
        onDefaultClick,
    }: INonKeywordGroupItemClickOptions,
) => {
    if (typeof onItemClickCustom === "function") {
        onItemClickCustom(item);
        return;
    }

    if (supportCountryFilters) {
        const keyword = typeof item === "string" ? item : item.name ?? String(item);
        onCountryFilterClick(keyword);
        return;
    }

    onDefaultClick();
};
